<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-title-row">
        <button class="editor-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <div class="editor-banner">
          <img src="assets/img/contactBar.png" alt="">
          <h1>Nuova scheda</h1>
        </div>
      </div>
      <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
    </header>

    <app-general-info [listType]="listType" [listRegionsCode]="listRegionsCode" (buttonClicked)="onButtonClicked($event)"></app-general-info>
  </div>
</div>
